import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'pv-address',
  templateUrl: './address.component.html',
  styleUrls: ['./address.component.scss']
})
export class AddressComponent implements OnChanges {
  @Input() header: any;
  @Input() address: any;
  @Input() review: boolean;
  @Input() selectable: boolean;
  @Input() editable: boolean;
  @Input() selected: boolean;
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDelete: EventEmitter<any> = new EventEmitter<any>();
  @Output() onBack: EventEmitter<any> = new EventEmitter<any>();

  deleting: boolean = false;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.address) {
      this.address = changes.address && changes.address.currentValue
    }
  }

  select() {
    if (!this.selectable) {
      return;
    }
    this.onSelect.emit()
  }

  edit() {
    this.onEdit.emit()
  }

  delete() {
    this.onDelete.emit()
  }

  goBack(){
    this.onBack.emit()
  }
}
